import * as React from 'react';
import * as styles from '../css/powering.css';
import PoweringImageContainer from '../components/PoweringImageContainer';
import PoweringImage from '../components/PoweringImage';
import Category from '../components/Category';

const Powering = () => (
    <div className={styles.container}>
        <Category standalone>Powering</Category>
        <PoweringImageContainer isGrayscale>
            <PoweringImage logo="bkk" />
            <PoweringImage logo="szombathely" />
            <PoweringImage logo="paks" />
            <PoweringImage logo="szekesfehervar" />
            <PoweringImage logo="vbusz" />
            <PoweringImage logo="kti" />
            <PoweringImage logo="mmkm" />
            <PoweringImage logo="otp" />
            <PoweringImage logo="mav" />
            <PoweringImage logo="stadtnavi" />
            <PoweringImage logo="tbusz" />
            <PoweringImage logo="thurybusz" />
        </PoweringImageContainer>
    </div>
);

export default Powering;
